import { useTranslation } from "react-i18next"

import motivationImageUrl from "@assets/motivation.png"
import Button from "@components/Button"
import Layout from "@components/Layout"
import { Form } from "react-router-dom"

export default function MotivationPage() {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center gap-5 text-center">
        <img
          src={motivationImageUrl}
          alt="Glad Icon"
          className="h-auto w-80 rounded-lg"
        />

        <h1 className="custom-heading">
          {t("pages.onboarding.motivation.heading")}
        </h1>

        <p className="text-lg">{t("pages.onboarding.motivation.text")}</p>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t("pages.onboarding.motivation.heading", { lng: "en" })}
          type="hidden"
          value={t("shared.continue", { lng: "en" })}
        />

        <Button title={t("shared.continue")} type="submit" />
      </Form>
    </Layout>
  )
}
